import { useSelector } from "react-redux"
import { hasRole } from "../../utils/roles"
import { selectFirestoreUser } from "../../features/auth/authSlice"

export function useRole() {
  const user = useSelector(selectFirestoreUser)

  return {
    user, // the Firestore user doc
    isAdmin: hasRole(user, 'admin'),  // A appAdmin implicitly counts as an admin
    isAppAdmin: hasRole(user, 'appAdmin'),
    isAffiliate: hasRole(user, 'affiliate'),
    isPhysician: hasRole(user, 'physician'),
    isStaff: hasRole(user, 'staff'),
  }
}